"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rangeTag = exports.contactsDate = exports.analyticsDate = exports.CONTACTS_DATE_FORMAT = exports.ANALYTICS_DATE_FORMAT = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var ANALYTICS_DATE_FORMAT = 'YYYYMMDD';
exports.ANALYTICS_DATE_FORMAT = ANALYTICS_DATE_FORMAT;
var CONTACTS_DATE_FORMAT = 'x'; // Unix Millisecond Timestamp

exports.CONTACTS_DATE_FORMAT = CONTACTS_DATE_FORMAT;

var analyticsDate = function analyticsDate(d) {
  return _I18n.default.moment(d).format(ANALYTICS_DATE_FORMAT);
};

exports.analyticsDate = analyticsDate;

var contactsDate = function contactsDate(d) {
  return _I18n.default.moment(d).format(CONTACTS_DATE_FORMAT);
};

exports.contactsDate = contactsDate;

var rangeTag = function rangeTag(start, end) {
  start = analyticsDate(start);
  end = analyticsDate(end);
  return start + "_" + end;
};

exports.rangeTag = rangeTag;